"use client";

import { Sparkles, Grape, Droplets } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
export default function Auditreportpreview() {
  const shouldReduceMotion = useReducedMotion();
  const ingredients = [{
    icon: Grape,
    title: "Revenue Audits",
    description: "We conduct deep-dive audits of your current revenue streams, identifying hidden leaks and untapped opportunities to boost your bottom line immediately."
  }, {
    icon: Droplets,
    title: "OTA Management",
    description: "Our experts optimize your OTA listings and distribution strategy, ensuring your property stands out and captures high-value bookings consistently."
  }, {
    icon: Sparkles,
    title: "Tech Integration",
    description: "We recommend and implement the right hospitality tech stack, streamlining your operations and automating revenue management for maximum efficiency."
  }];
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.12
      }
    }
  };
  const cardVariants = {
    hidden: shouldReduceMotion ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 24
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0 : 0.7,
        ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
      }
    }
  };
  return <section data-section-id="28192" id="auditreportpreview" data-nav="light" className="relative w-full bg-background text-foreground py-24 md:py-36 overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-10 -left-10 w-48 h-48 rounded-lg opacity-40" style={{
        backgroundColor: "var(--secondary)"
      }} />
        <div className="absolute top-1/3 right-8 w-24 h-24 rounded-lg opacity-50" style={{
        backgroundColor: "var(--accent)"
      }} />
        <div className="absolute bottom-16 left-1/4 w-16 h-16 rounded-lg opacity-40" style={{
        backgroundColor: "var(--primary)"
      }} />
      </div>

      <div className="relative mx-auto max-w-[1320px] px-5 sm:px-8 md:px-14">
        {}
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: shouldReduceMotion ? 0 : 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto max-w-[780px] text-center">
          <p className="font-default text-xs md:text-sm font-semibold uppercase mb-5" style={{
          color: "var(--secondary)",
          letterSpacing: "0.14em"
        }}>
            Our Core Expertise
          </p>
          <h2 className="font-serif text-foreground mb-6" style={{
          fontSize: "clamp(2.25rem, 4.5vw, 4rem)",
          fontWeight: 500,
          letterSpacing: "-0.025em",
          lineHeight: 1.02
        }}>
            {"Data-Driven "}
            <em className="italic" style={{
            color: "var(--secondary)"
          }}>
              Revenue Growth
            </em>
          </h2>
          <p className="font-default text-muted-foreground mx-auto" style={{
          fontSize: "clamp(1.05rem, 1.2vw, 1.25rem)",
          fontWeight: 400,
          lineHeight: 1.55,
          maxWidth: "620px"
        }}>
            {"We provide professional revenue management consulting to help hotel owners maximize profitability through proven, data-backed strategies."}
          </p>
        </motion.div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {ingredients.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={item.title} data-index={i} variants={cardVariants} whileHover={shouldReduceMotion ? {} : {
            scale: 1.02,
            transition: {
              duration: 0.35,
              ease: [0.34, 1.56, 0.64, 1]
            }
          }} className="group relative bg-card p-7 md:p-10 flex flex-col transition-colors duration-300" style={{
            borderRadius: "var(--radius)",
            border: "3px solid var(--border)"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLDivElement).style.borderColor = "var(--secondary)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLDivElement).style.borderColor = "var(--border)";
          }}>
                {}
                <motion.div whileHover={shouldReduceMotion ? {} : {
              rotate: 8,
              transition: {
                duration: 0.4,
                ease: [0.34, 1.56, 0.64, 1]
              }
            }} className="relative mb-6 inline-flex items-center justify-center" style={{
              width: "64px",
              height: "64px"
            }}>
                  <span className="absolute inset-0 rounded-lg opacity-90" style={{
                backgroundColor: "var(--accent)"
              }} aria-hidden="true" />
                  <Icon className="relative" style={{
                width: "36px",
                height: "36px",
                color: "var(--secondary)",
                strokeWidth: 1.75
              }} aria-hidden="true" />
                </motion.div>

                {}
                <h3 className="font-serif text-card-foreground mb-3" style={{
              fontSize: "clamp(1.5rem, 2.4vw, 2.25rem)",
              fontWeight: 500,
              letterSpacing: "-0.02em",
              lineHeight: 1.1
            }}>
                  {item.title}
                </h3>

                {}
                <p className="font-default text-muted-foreground" style={{
              fontSize: "1rem",
              fontWeight: 400,
              lineHeight: 1.6
            }}>
                  {item.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}